import { render } from "./MypageBuyToken.vue?vue&type=template&id=7bf96963&scoped=true"
import script from "./MypageBuyToken.vue?vue&type=script&lang=js"
export * from "./MypageBuyToken.vue?vue&type=script&lang=js"

import "@/assets/css/components/Mypage/mypage_pay.css?vue&type=style&index=0&id=7bf96963&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf96963"]])

export default __exports__